import {
  FETCH_EQUIPMENT_REPORT,
  FETCH_EQUIPMENT_REPORT_CONTINUE_SUCCESS,
  FETCH_EQUIPMENT_REPORT_REFRESH_SUCCESS,
  FETCH_EQUIPMENT_REPORT_FAILURE,
} from "features/yard360/store/equipmentReport/types";
import {
  UPDATE_EQUIPMENT_INFO,
  UPDATE_EQUIPMENT_INFO_SUCCESS,
  UPDATE_EQUIPMENT_INFO_FAILURE,
  CLEAR_UPDATE_EQUIPMENT_INFO_ERROR,
} from "features/yard360/store/equipmentReport/updateEquipmentInfo/types";

export const INITIAL_EQUIPMENT_REPORT = {
  allMatchedEquipmentRecordsCount: null,
  nextToken: null,
  equipmentRecords: null,
  fetchingEquipmentReport: false,
  errorMessage: null,
};

export const equipmentReportReducer = (state = INITIAL_EQUIPMENT_REPORT, action) => {
  switch (action.type) {
    // ----------------------------------------------------------
    //                   Fetch equipment report
    // ----------------------------------------------------------
    case FETCH_EQUIPMENT_REPORT:
      return {
        ...state,
        fetchingEquipmentReport: true,
        errorMessage: null,
      };

    case FETCH_EQUIPMENT_REPORT_CONTINUE_SUCCESS: {
      const { allMatchedEquipmentRecordsCount, nextToken, equipmentRecords } = action.payload;
      return {
        ...state,
        allMatchedEquipmentRecordsCount,
        nextToken,
        equipmentRecords: [...state.equipmentRecords, ...equipmentRecords],
        fetchingEquipmentReport: false,
        errorMessage: null,
      };
    }

    case FETCH_EQUIPMENT_REPORT_REFRESH_SUCCESS: {
      const { allMatchedEquipmentRecordsCount, nextToken, equipmentRecords } = action.payload;
      return {
        ...state,
        allMatchedEquipmentRecordsCount,
        nextToken,
        equipmentRecords: equipmentRecords || [],
        fetchingEquipmentReport: false,
        errorMessage: null,
      };
    }

    case FETCH_EQUIPMENT_REPORT_FAILURE: {
      const { errorMessage } = action.payload;
      return {
        ...state,
        fetchingEquipmentReport: false,
        errorMessage,
      };
    }

    // ----------------------------------------------------------
    //                   Update equipment info
    // ----------------------------------------------------------

    case UPDATE_EQUIPMENT_INFO: {
      const { equipmentVisitId } = action.payload;
      return {
        ...state,
        equipmentRecords: state.equipmentRecords.map((equipmentRecord) => {
          if (equipmentRecord.equipmentVisitId === equipmentVisitId) {
            return {
              ...equipmentRecord,
              updatingEquipmentInfo: true,
              errorMessage: null,
            };
          }
          return equipmentRecord;
        }),
      };
    }

    case UPDATE_EQUIPMENT_INFO_SUCCESS: {
      const { equipmentVisitId, equipment } = action.payload;
      const {
        equipmentEmptyStatus,
        notes,
        contentMetadata: { contentTags },
      } = equipment;
      return {
        ...state,
        equipmentRecords: state.equipmentRecords.map((equipmentRecord) => {
          if (equipmentRecord.equipmentVisitId === equipmentVisitId) {
            return {
              ...equipmentRecord,
              equipmentEmptyStatus,
              note: notes,
              contentTags,
              updatingEquipmentInfo: false,
              errorMessage: null,
            };
          }
          return equipmentRecord;
        }),
      };
    }

    case UPDATE_EQUIPMENT_INFO_FAILURE: {
      const { equipmentVisitId, errorMessage } = action.payload;
      return {
        ...state,
        equipmentRecords: state.equipmentRecords.map((equipmentRecord) => {
          if (equipmentRecord.equipmentVisitId === equipmentVisitId) {
            return {
              ...equipmentRecord,
              updatingEquipmentInfo: false,
              errorMessage,
            };
          }
          return equipmentRecord;
        }),
      };
    }

    case CLEAR_UPDATE_EQUIPMENT_INFO_ERROR: {
      const { equipmentVisitId } = action.payload;
      return {
        ...state,
        equipmentRecords: state.equipmentRecords.map((equipmentRecord) => {
          if (equipmentRecord.equipmentVisitId === equipmentVisitId) {
            return {
              ...equipmentRecord,
              updatingEquipmentInfo: false,
              errorMessage: null,
            };
          }
          return equipmentRecord;
        }),
      };
    }

    default:
      return state;
  }
};
